var directFullscreenHelper = /** @class */ (function () {
    function directFullscreenHelper() {
    }
    //constructor() {}
    directFullscreenHelper.prototype.getDirectFullscreenFromParams = function (queryParams) {
        var fullscreenParam = queryParams && queryParams.pgid;
        if (fullscreenParam) {
            var index = fullscreenParam.indexOf('-');
            var compId = 'comp-' + fullscreenParam.substring(0, index);
            var itemId = fullscreenParam.substring(index + 1, fullscreenParam.length);
            return (compId &&
                itemId && {
                compId: compId,
                itemId: itemId,
            });
        }
        else {
            return false;
        }
    };
    directFullscreenHelper.prototype.getDirectFullscreenItemFromItemsList = function (queryParams, items, compId) {
        var directfullscreenParams = this.getDirectFullscreenFromParams(queryParams);
        if (directfullscreenParams && directfullscreenParams.compId !== compId) {
            return undefined;
        }
        if (directfullscreenParams && items) {
            return items[items.findIndex(function (item) { return item.itemId === directfullscreenParams.itemId && !item.metaData.isVideoPlaceholder; })];
        }
        else {
            return undefined;
        }
    };
    directFullscreenHelper.prototype.getDirectFullscreenPromise = function (galleryCompId, queryParams, proGalleryStore, isSSR) {
        var directfullscreenParams = this.getDirectFullscreenFromParams(queryParams);
        if (directfullscreenParams &&
            galleryCompId === directfullscreenParams.compId) {
            return proGalleryStore.loadDirectFullscreen(directfullscreenParams.itemId, isSSR);
        }
        else {
            return Promise.resolve(0);
        }
    };
    directFullscreenHelper.prototype.setMetaTagsForItemIfNeeded = function (props, item) {
        var isInSEO = props.isInSEO;
        if (item && isInSEO) {
            var type = 'image'; // TODO - connect the real deal. could be galleryItem.js L1035 - and understand how it matters? maybe i dont need this one.
            var dto = item.metaData;
            props.setMetaTags && props.setMetaTags(type, dto);
        }
    };
    return directFullscreenHelper;
}());
export default new directFullscreenHelper();
//# sourceMappingURL=directFullscreenHelper.js.map